import { PersonalizeProductComponent } from './../../modules/modals/personalize-product/personalize-product.component';
import { WebSiteUsersService } from './../../services/webSiteUsers/webSiteUsers.service';
import { localStorageService } from './../../services/localStorage/localStorage.service';
import { FamilyService } from './../../services/family/family.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PdvService } from '../../services/pdv/pdv.service';
import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { Component, EventEmitter, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subscription } from "rxjs";
import { OrdersService } from '../../services/order/orders.service';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'summary',
    templateUrl: 'summary.component.html',
    styleUrls: ['summary.component.scss']
})

export class SummaryComponent {
    order: any = {};
    elementsNbr: number;
    chosenOrderType: number;
    orderTypLabel: string;
    @Output()
    onNext: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild("template")
    template;
    @ViewChild("template2")
    template2;
    updatePanier = true;
    bsModalRef: BsModalRef;
    modalRef: BsModalRef;
    subscriptions: Subscription[] = [];
    amountMiniDelivery: number;
    amountMiniMandatory: number;
    discount: number = 0;
    discountFrom: number = 0;
    constructor(
        private orderService: OrdersService,
        private pdvService: PdvService,
        private modalService: BsModalService,
        private changeDetection: ChangeDetectorRef,
        private toastr: ToastrService,
        private familyService: FamilyService,
        private router: Router,
    ) {
        this.orderService.order.subscribe(
            (order) => {
                this.order = order;
            }
        )
        const sub5 = this.orderService.amountMiniDelivery.subscribe(amountMiniDelivery => {
            this.amountMiniDelivery = amountMiniDelivery;
        });
        this.orderService.elementsNbr.subscribe(
            (elementsNbr) => {
                this.elementsNbr = elementsNbr;
                if (elementsNbr == 0) {
                    this.router.navigate(['/carte'])
                }
            }
        )
        this.orderService.chosenOrderType.subscribe((chosenOrderType) => {
            this.chosenOrderType=chosenOrderType;
        });
        this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            if (orderTypes.length >= 1 && this.chosenOrderType > 0) {
                this.orderTypLabel = orderTypes.filter(o => o.id == this.chosenOrderType)[0].label
            }
        });
        const subs6 = this.pdvService.pdv.subscribe(
            (data: any) => {
                this.amountMiniMandatory = data.amountMiniMandatory;
                this.discount=data.discount;
                this.discountFrom=data.discountFrom;
            }
        )
        this.subscriptions.push(sub5, subs6);
    }
    changeMode() {
        if (this.elementsNbr > 0) {
            this.modalRef = this.modalService.show(this.template, {
                class: "ordertype-modal"
            });
        } else {
            this.router.navigate(['/modes']);
        }
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    confirm() {
        this.orderService.clearOrder();
        if (this.modalRef) {
            this.modalRef.hide();
        }
        this.router.navigate(['/modes']);
    }

    confirm2() {
        this.modalRef.hide();
        this.orderService.order.next(this.order);
        this.onNext.emit(true);
    }

    decline() {
        this.modalRef.hide();
    }

    incrQty(i, j) {
        this.orderService.incrQty(i, j);
    }

    decrQty(i, j) {
        this.orderService.decrQty(i, j);
    }

    removeElement(i, j) {
        this.orderService.removeElement(i, j);
    }
    back() {
        this.familyService.families.subscribe(
            (families: any[]) => {
                this.router.navigate(['/carte/famille/' + families[0].slug])
            }
        )
    }
    updateElement(i) {
        if (this.updatePanier) {
          const _combine = combineLatest(
            this.modalService.onHidden
          ).subscribe(() => this.changeDetection.markForCheck());
          this.subscriptions.push(
            this.modalService.onHidden.subscribe((element: any) => {
              if (element) {
                this.orderService.updateElement(element,i);
              }
              this.unsubscribe();
            })
          );
          this.subscriptions.push(_combine);
          this.bsModalRef = this.modalService.show(PersonalizeProductComponent, {
            class: "modal-content3"
          });
          this.bsModalRef.content.product2 = JSON.parse(
            JSON.stringify(this.order.elements[i])
          );
        }
      }

    validate() {
        if (this.chosenOrderType == 1) {
            if (Number(this.order.total) >= Number(this.amountMiniDelivery)) {
                this.orderService.order.next(this.order);
                this.onNext.emit(true);
            } else {
                if (this.amountMiniMandatory == 0) {
                    this.modalRef = this.modalService.show(this.template2, { class: 'modal-sm' });
                } else {
                    this.toastr.error('', 'Montant minimum de livraison: ' + this.amountMiniDelivery + ' €');
                }
            }
        } else {
            this.orderService.order.next(this.order);
            this.onNext.emit(true);
        }

    }
    onDistroy() {
        this.unsubscribe();
    }
}
